import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { ReportOption } from '../types';

const SET_SELECTED_REPORT = 'PORTFOLIO_REPORTS.SET_SELECTED_REPORT';

const RESET_STATE = 'PORTFOLIO_REPORTS.RESET_STATE';

export const setSelectedReport = (payload: string) => ({
  type: SET_SELECTED_REPORT,
  payload,
});

export const resetState = () => ({
  type: RESET_STATE,
});

const initialState = {
  selectedReport: null,
};

export const portfolioReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_REPORT: {
      return {
        ...state,
        selectedReport: action.payload,
      };
    }

    case RESET_STATE: {
      return initialState;
    }

    default:
      return state;
  }
};

const portfolioReportsSelector = state => state.portfolioReports;

const selectedReportSelector = createSelector(
  portfolioReportsSelector,
  ({ selectedReport }) => selectedReport,
);

export const useSelectedReport = (): {
  selectedReport: ReportOption | null;
} => {
  const selectedReport = useSelector(selectedReportSelector);

  return {
    selectedReport,
  };
};
